import React from "react"
import moment from "moment"
import useDate from "../../hooks/useDate"
import { DateTime } from "luxon"

interface Props {
  meetingDetails: any
  coachName: any
  activeService: any
}

const MeetingDetailsPanel: React.FC<Props> = ({
  meetingDetails,
  coachName,
  activeService,
}) => {
  const { mdDate } = useDate()

  const getUserTimezone = () => {
    const localDateTime = DateTime.now().zoneName
    const longTimezoneName = DateTime.now().offsetNameLong
    return `${longTimezoneName} - ${localDateTime}`
  }

  const userTimezone = getUserTimezone()

  const getDetailsText = () => {
    if (activeService?.service_details?.type === "consultation") {
      return "Coach Details"
    } else {
      return "Meeting Details"
    }
  }

  return (
    <div className="mb-[24px] flex flex-col gap-[12px]">
      <h3 className="mb-[12px] text-[22px] font-bold">{getDetailsText()}</h3>
      <div className="promotion-shadow relative flex flex-col rounded-[16px] bg-white px-[24px] pb-[24px] pt-[28px] md:px-[40px] md:py-[32px]">
        <p className="text-grayCharcoal mb-[16px] text-base font-bold">
          COACH
        </p>
        <div className="flex w-full items-center gap-[12px]">
          <div className="text-base font-bold">{coachName}</div>
        </div>
      </div>
      {meetingDetails && (
        <div className="bg-grayMist relative rounded-[16px] px-[24px] pb-[24px] pt-[28px] md:px-[40px] md:py-[32px]">
          <p className="text-grayCharcoal mb-[16px] text-base font-bold">
            WHEN
          </p>
          <div>
            {meetingDetails.startTime ? (
              <>
                <p className="mb-[8px] text-[16px] font-bold">
                  {`${mdDate(meetingDetails.startTime)}, ${userTimezone}`}
                </p>
                <div className="text-graySlate flex gap-[4px] text-base">
                  <p className="font-bold text-black">
                    &nbsp;
                    {moment(meetingDetails.startTime).format("h:mm A")}
                  </p>
                  -
                  <p className="font-bold text-black">
                    &nbsp;
                    {moment(meetingDetails.endTime).format("h:mm A")}
                  </p>
                </div>
              </>
            ) : (
              <p className="text-vividOrange text-base">No date selected</p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default MeetingDetailsPanel
